/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Meta_TitleInputs */

const es_billing_meta_title = /** @type {(inputs: Billing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Facturación y uso`)
};

const en_billing_meta_title = /** @type {(inputs: Billing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Billing & Usage`)
};

/**
* | output |
* | --- |
* | "Nexata \| Billing & Usage" |
*
* @param {Billing_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_meta_title = /** @type {((inputs?: Billing_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_meta_title(inputs)
	return en_billing_meta_title(inputs)
});
export { billing_meta_title as "billing.meta.title" }